import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
import StatWidgetBox from './StatWidgetBox';
import { useSelector } from 'react-redux';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import { useGetBannersQuery } from "@/api/banners";
import TooltipContentContainer from './partials/TooltipContentContainer';

const MonitoringChip = ({ onClick, open}) => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner, isLoading } = useGetBannersQuery(activeBuildingId);
  const count = banner?.monitoring?.length ?? 0;
  
  return (
    <StatWidgetBox
      icon={<SettingsIcon sx={{ fontSize: 16 }}/>}
      value={count}
      loading={isLoading}
      skeletonWidth={8}
      onClick={onClick}
      tooltipContent={open && <TooltipContent />}
    />
  );
};

const TooltipContent = () => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner } = useGetBannersQuery(activeBuildingId);
  const { t } = useTranslation();
  return (
    <TooltipContentContainer
      backgroundColor={'rgb(229, 30, 30)'}
      backgroundGradient="linear-gradient(140.9deg, rgb(249, 144, 144) -14.02%, rgba(249, 144, 144, 0) 77.58%)"
      icon={<SettingsIcon sx={{ fontSize: 14, color: 'white' }} />}
      iconBackground={'rgba(255, 255, 255, 0.2)'}
      title={t('monitoring')}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {banner?.monitoring?.map((monitoring) => (
          <Box
            key={monitoring.id}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '4px',
              padding: '8px',
              textAlign: 'center'
            }}
          >
            <Typography sx={{ fontSize: '13px', fontWeight: 'medium' }}>
              {monitoring?.name || '-'}
            </Typography>
          </Box>
        ))}
      </Box>
    </TooltipContentContainer>
  );
}


export default MonitoringChip;
